import { writable } from "svelte/store";
import * as _ from "lodash";
import * as actionCable from "actioncable";
import retailerContext from "@modern/services/retailer_context";

var service = function () {
  let newMessageContext: { new_message: any } = null;
  let updatedMessageContext: { updated_message: any } = null;

  let newMessageStore, updatedMessageStore;
  let channel, cable;

  async function initialize() {
    let retailer = retailerContext.get();
    createStores();
    if (retailer) {
      subscribeToWebsocket(retailer.id);
    }
  }

  function createStores() {
    createNewMessageStore();
    createUpdatedMessageStore();
  }

  function createNewMessageStore() {
    newMessageStore = writable(newMessageContext);
  }

  function createUpdatedMessageStore() {
    updatedMessageStore = writable(updatedMessageContext);
  }

  function setNewMessageStore(data) {
    newMessageStore.set(data);
  }

  function setUpdatedMessageStore(data) {
    updatedMessageStore.set(data);
  }

  function subscribeToWebsocket(retailerId) {
    cable = actionCable.createConsumer("/cable");
    channel = cable.subscriptions.create(
      { channel: "MessagesChannel", messageId: retailerId },
      {
        received: function (data) {
          if (data.message || data.message == 0) {
            // todo
            // unreadMessages.count = parseInt(data.message);
          } else if (data.new_message) {
            setNewMessageStore(data);
          } else if (data.updated_message) {
            setUpdatedMessageStore(data);
          }
        },
      },
    );
  }

  function getNewMessageStore() {
    return newMessageStore;
  }

  function getUpdatedMessageStore() {
    return updatedMessageStore;
  }

  function unsubscribeFromWebsocket() {
    if (cable) {
      cable.subscriptions.remove(channel);
    }
  }

  return {
    initialize: initialize,
    getNewMessageStore: getNewMessageStore,
    getUpdatedMessageStore: getUpdatedMessageStore,
    unsubscribe: unsubscribeFromWebsocket,
  };
};
const messagesContext = service();
export default messagesContext;
